import type { SVGProps } from 'react'
import type { ThemePreference } from '../contexts/ThemeContext'

export function BrandLogo({ compact = false }: { compact?: boolean }) {
  return (
    <span className={compact ? 'brand-logo brand-logo--compact' : 'brand-logo'}>
      <svg
        className="brand-logo__mark"
        viewBox="0 0 32 32"
        role="img"
        aria-label="iLoveSing 段落路徑標記"
      >
        <circle className="brand-logo__node" cx="5.5" cy="9.5" r="2.5" />
        <path className="brand-logo__path" d="M10 9.5h13.2a3.3 3.3 0 0 1 3.3 3.3v.7" />
        <path className="brand-logo__path brand-logo__path--active" d="M5.5 22.5h13a4 4 0 0 0 4-4" />
      </svg>
      <span className="brand-logo__wordmark">iLoveSing</span>
    </span>
  )
}

type IconProps = SVGProps<SVGSVGElement>

function SunIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="3.6" />
      <path d="M12 2.4v2.1M12 19.5v2.1M2.4 12h2.1M19.5 12h2.1M5.2 5.2l1.5 1.5M17.3 17.3l1.5 1.5M18.8 5.2l-1.5 1.5M6.7 17.3l-1.5 1.5" />
    </svg>
  )
}

function MoonIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path d="M20.1 15.3a8.7 8.7 0 0 1-11.4-11 8.8 8.8 0 1 0 11.4 11Z" />
    </svg>
  )
}

function SystemIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <rect x="3.2" y="4.2" width="17.6" height="12.1" rx="1.8" />
      <path d="M8.5 20h7M12 16.3V20" />
      <path d="M7.2 10.3a4.8 4.8 0 0 0 7.6 3.9A5.2 5.2 0 0 1 10 6.4a4.8 4.8 0 0 0-2.8 3.9Z" />
    </svg>
  )
}

export function ThemeIcon({ theme, ...props }: IconProps & { theme: ThemePreference }) {
  if (theme === 'dark') return <MoonIcon {...props} />
  if (theme === 'system') return <SystemIcon {...props} />
  return <SunIcon {...props} />
}
